import { dietSettingsGetCurrentStepPositon } from './DietSettingsGetCurrentStepPositionAction';
import { dietSettingsGetSchemaForParameters } from './DietSettingsSchemaForParametersAction';

export const dietSettingsIsLastStep = (schema, parameters, currentStepIdentifier) => {
  const currentStepPositon = dietSettingsGetCurrentStepPositon(
    schema,
    parameters,
    currentStepIdentifier
  );

  const schemaForParameters = dietSettingsGetSchemaForParameters(schema, parameters);

  return currentStepPositon === schemaForParameters.length;
};
